import React, { Fragment } from 'react'
import styled from 'styled-components'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { defaultLocale } from 'i18n'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/organisms/GoogleTagManager'
import Header from 'containers/organisms/Header'
import Footer from 'components/organisms/Footer'
import Firebase from 'components/organisms/Firebase'
import GlobalStyle from 'styles/extra/ant-design'

export default props => {
  const { children, config } = props
  const title = i18n.t(props.title || 'server.shared.default_title')
  const siteName = i18n.t(props.siteName || 'server.shared.default_site_name')
  const description = i18n.t(
    props.description || 'server.shared.default_description',
  )
  const url = props.url || ''
  const image = props.image || imagePath('service/common/ogimage.png')
  const bodyClassNames = ['site-service']
  if (props.bodyClassName) bodyClassNames.push(props.bodyClassName)

  const meta = {
    title: `${title} - ${siteName}`,
    description,
    og: {
      title,
      description,
      url,
      image,
      siteName,
      type: 'website',
      locale: defaultLocale,
    },
    twitter: {
      title,
      description,
      url,
      image: { src: image },
      card: 'summary_large_image',
      site: '@spacemarketjp',
      creator: '@spacemarketjp',
    },
  }

  function renderAll(element) {
    return (
      <html>
        <head>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
          {props.isNoIndex && (
            <meta name="robots" content="noindex, nofollow" />
          )}
          <link
            rel="stylesheet"
            href={manifest['account/main.css']}
            media="screen"
          />
          <link
            rel="stylesheet"
            href="https://use.fontawesome.com/releases/v5.0.13/css/all.css"
            integrity="sha384-DNOHZ68U8hZfKXOrtjWvjxusGo9WQnrNx2sqG0tfsghAvtVlRW3tvkXWZh58N9jp"
            crossOrigin="anonymous"
          />
          <link rel="shortcut icon" href={imagePath('favicon.ico')} />
          <link
            rel="apple-touch-icon"
            href={imagePath('common/apple-touch-icon.png')}
          />
          <meta property="fb:app_id" content={props.config.FACEBOOK_APP_ID} />
          <meta property="og:site_name" content={meta.og.siteName} />
          <meta property="og:title" content={meta.og.title} />
          <meta property="og:description" content={meta.og.description} />
          <meta property="og:type" content={meta.og.type} />
          <meta property="og:url" content={meta.og.url} />
          <meta property="og:locale" content={meta.og.locale} />
          <meta property="og:image" content={meta.og.image} />
          <meta name="twitter:card" content={meta.twitter.card} />
          <meta name="twitter:site" content={meta.twitter.site} />
          <meta name="twitter:creator" content={meta.twitter.creator} />
          <meta name="twitter:title" content={meta.twitter.title} />
          <meta name="twitter:description" content={meta.twitter.description} />
          <meta name="twitter:url" content={meta.twitter.url} />
          <meta name="twitter:image:src" content={meta.twitter.image.src} />
          {props.linkCanonical && (
            <link rel="canonical" href={props.linkCanonical} />
          )}
          {props.linkNext && <link rel="next" href={props.linkNext} />}
          {props.linkPrev && <link rel="prev" href={props.linkPrev} />}
          <link rel="dns-prefetch" href="//account.spacemarket.com" />
          {props.appLinks && (
            <meta
              property="al:ios:url"
              content={`spacemarket:/${props.appLinks}`}
            />
          )}
          {props.appLinks && (
            <meta property="al:ios:app_store_id" content={meta.appStoreId} />
          )}
          {props.appLinks && (
            <meta property="al:ios:app_name" content={meta.name} />
          )}
          {props.amp && <link rel="amphtml" href={props.amp} />}
          <meta
            name="google-site-verification"
            content="cmoKhQQsQ4qUSCi8OyEvVogn5rLN77ObhTYe5pWXcBk"
          />
          {props.isSignUpPage && (
            <script
              src="https://www.google.com/recaptcha/api.js?render=explicit"
              async
              defer
            />
          )}
          {props.isShowZendeskChat && (
            <script
              id="ze-snippet"
              src="https://static.zdassets.com/ekr/snippet.js?key=a4d4f056-668d-40df-b7ca-e39ac771be5a"
            />
          )}
          <script
            src="https://browser.sentry-cdn.com/4.6.6/bundle.min.js"
            crossOrigin="anonymous"
          />
          <GoogleTagManagerHead />
        </head>
        <body className={bodyClassNames.join(' ')}>
          <GoogleTagManagerBody />
          <StyledRenderRoot id="js-root">{renderRoot()}</StyledRenderRoot>
        </body>
      </html>
    )
  }

  function renderRoot() {
    return (
      <Fragment>
        <GlobalStyle />
        <StyledContainer>
          {!props.isHostEntryPage && <Header {...props} />}
          <div className="site-main">{children}</div>
          <Footer {...props} />
          <Firebase config={props.config} />
        </StyledContainer>
      </Fragment>
    )
  }

  return config.SSR ? renderAll() : renderRoot()
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  /* 100vh hack for Android & iOS Safari */
  @supports (-webkit-touch-callout: none) {
    min-block-size: -webkit-fill-available;
  }
`
const StyledRenderRoot = styled.div`
  display: flex;
`
